import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';


// https://api.akaun.cloud/core2/tnt/dm/app-login-subject/backoffice-ep


@Injectable({providedIn: 'root'})
export class AppLoginSubjectService extends BaseApiTemplateService<any> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'app-login-subject/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'app-login-subject/backoffice-ep';
    this.httpClient = http;
  }
}
